import { render, staticRenderFns } from "./CustomizableHeader.vue?vue&type=template&id=5d937a72&scoped=true&"
import script from "./CustomizableHeader.vue?vue&type=script&lang=js&"
export * from "./CustomizableHeader.vue?vue&type=script&lang=js&"
import style0 from "./CustomizableHeader.vue?vue&type=style&index=0&id=5d937a72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d937a72",
  null
  
)

export default component.exports